import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAppStore } from "../../store/useAppStore";
import { LogOut, Menu, X } from "lucide-react";
import Sidebar from "./Sidebar";

const MainLayout = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(true);
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const user = useAppStore((state) => state.user);
  const logout = useAppStore((state) => state.logout);

  //const theme = useAppStore((state) => state.theme);
  //const toggleTheme = useAppStore((state) => state.toggleTheme);

  const handleLogout = () => {
    logout();
  };

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const toggleMobileSidebar = () => {
    setIsMobileSidebarOpen(!isMobileSidebarOpen);
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {/* Header */}
      <header className="sticky top-0 z-50 w-full border-b border-border bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="flex h-16 items-center justify-between px-3 sm:px-4">
          <div className="flex items-center gap-2">
            {/* Toggle Sidebar - Desktop */}
            <button
              onClick={toggleSidebar}
              className="hidden lg:flex items-center justify-center h-10 w-10 rounded-soft hover:bg-muted transition-smooth"
              aria-label="Toggle sidebar"
              title={isSidebarCollapsed ? "Expandir menú" : "Contraer menú"}
            >
              <Menu className="h-5 w-5 text-foreground" />
            </button>

            {/* Toggle Sidebar - Mobile */}
            <button
              onClick={toggleMobileSidebar}
              className="lg:hidden flex items-center justify-center h-10 w-10 rounded-soft hover:bg-muted transition-smooth"
              aria-label="Toggle mobile menu"
            >
              {isMobileSidebarOpen ? (
                <X className="h-5 w-5 text-foreground" />
              ) : (
                <Menu className="h-5 w-5 text-foreground" />
              )}
            </button>

            <div className="flex items-center gap-2">
              {/* <div className="h-8 w-8 rounded-soft bg-primary" /> */}
              <h1 className="hidden sm:block text-lg sm:text-xl font-heading font-bold text-foreground">
                ADMINISTRACIÓN
              </h1>
            </div>
          </div>

          <div className="flex items-center gap-4">
            {/* Toggle de tema */}
            {/* <button
              onClick={toggleTheme}
              className="rounded-soft p-2 hover:bg-muted transition-smooth"
              aria-label="Cambiar tema"
              title={theme === "dark" ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
            >
              {theme === "dark" ? (
                <Sun className="h-5 w-5 text-foreground" />
              ) : (
                <Moon className="h-5 w-5 text-foreground" />
              )}
            </button> */}

            {/* Info del usuario */}
            {user && (
              <div className="flex items-center gap-2 sm:gap-3">
                <div className="hidden md:block text-right">
                  <p className="text-sm font-medium text-foreground">
                    {user.name}
                  </p>
                  <p className="text-xs text-muted-foreground">{user.role}</p>
                </div>
                {user.avatar ? (
                  <img
                    src={user.avatar}
                    alt={user.name}
                    className="h-10 w-10 rounded-pill object-cover"
                  />
                ) : (
                  <div className="h-10 w-10 rounded-pill bg-primary flex items-center justify-center text-primary-foreground font-medium">
                    {user.name.charAt(0).toUpperCase()}
                  </div>
                )}
              </div>
            )}

            {/* Botón de logout */}
            <button
              onClick={handleLogout}
              className="flex items-center justify-center gap-2 rounded-soft bg-destructive p-2 sm:px-4 sm:py-2 text-sm font-medium text-destructive-foreground hover:bg-destructive/90 transition-smooth"
            >
              <LogOut className="h-6 w-6 " />
              <span className="hidden sm:inline">Salir</span>
            </button>
          </div>
        </div>
      </header>

      {/* Layout con Sidebar */}
      <div className="flex flex-1 overflow-hidden">
        {/* Sidebar - Desktop */}
        <div className="hidden lg:block">
          <Sidebar isCollapsed={isSidebarCollapsed} />
        </div>

        {/* Sidebar - Mobile */}
        {isMobileSidebarOpen && (
          <>
            {/* Overlay */}
            <div
              className="fixed inset-0 bg-background/80 backdrop-blur-sm z-40 lg:hidden h-full"
              onClick={toggleMobileSidebar}
            />
            {/* Sidebar Mobile */}
            <div className="absolute inset-y-0 left-0 z-50 w-64 lg:hidden h-full shadow-xl">
              <Sidebar isCollapsed={false} />
            </div>
          </>
        )}

        {/* Contenido principal */}
        <main className="flex-1 flex flex-col overflow-hidden m-1">

          <div className="flex-1 overflow-hidden">
            <Outlet />
          </div>

          {/* Footer */}
          <footer className="border-t border-border bg-muted/50 py-6 w-full shrink-0">
            <div className="container-custom text-center text-sm text-muted-foreground px-4">
              © 2026 Jom. Todos los derechos reservados.
            </div>
          </footer>

        </main>
      </div>
    </div>
  );
};

export default MainLayout;
